<template>
  <div class="personalIndex xi">
    <nh-com></nh-com>
    <div class="personal-content">
      <div class="personal-box clearfix">
        <div class="personal-left">
          <hd-img :active="5"></hd-img>
        </div>
        <div class="personal-right">
          <div class="content">
            <div class="flex-start">
              <div class="line-title"></div>
              <div class="pageTitle">转账管理</div>
            </div>
            <div class="flex-center">
              <div class="part-box">
                <el-form :model="formData" status-icon ref="formData" label-width="100px" class="demo-RechargeForm" :rules="rules">
                  <el-form-item label="手机号">
                    <el-input placeholder="请输入手机号" v-model="formData.phone">
                      <el-button slot="append" icon="el-icon-search" @click="searchUser">查询收款账号</el-button>
                    </el-input>
                    <!-- <div style="color: #f23636" v-if="formData.phone && formData.payeeUserId == 0">未找到该账号相关用户</div> -->
                  </el-form-item>
                  <el-form-item label="收款账号" v-if="payeeUser.id">
                    <el-tag closable type="success" @close="handleClose()"> 用户：{{ payeeUser.userName }} </el-tag>
                  </el-form-item>
                  <el-form-item label="">
                    <div>
                      可用余额：<span style="font-size: 12px">￥</span><span style="font-size: 20px">{{ UserBalance.assetsBalance>0?UserBalance.assetsBalance.toFixed(2):'0' }}</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="转账金额" prop="amount">
                    <el-input-number v-model="formData.amount" :precision="2" :step="1" :min="0.00" :max="UserBalance.assetsBalance" controls-position="right" style="width: 300px" />
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="saveData('formData')">确定转账</el-button>
                    <div style="margin: 10px 0">温馨提示：转账前请确认收款人账号无误、检查账户余额、核对转账金额</div>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 支付 -->
    <el-dialog title="确认转账信息" :visible.sync="dialog1" width="500px">
      <div class="bg">
        <div>转账至：{{ payeeUser.userName }} {{ payeeUser.phone }}</div>
        <div style="color: #ff0101">转账金额：￥{{ formData.amount.toFixed(2) }}</div>
      </div>
      <div style="color: #fd403b">* 请确认转账信息，一旦转账成功，将不可恢复，请谨慎操作</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog1 = false">取 消</el-button>
        <el-button
          type="primary"
          @click="
            dialog1 = false;
            dialog2 = true;
          "
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="支付密码" :visible.sync="dialog2" width="500px">
      <el-form class="dialog-form" :model="formData" ref="formData" label-width="120px" :rules="rules">
        <el-form-item label="支付密码" prop="payPwd">
          <el-input type="password" maxlength="6" v-model="formData.payPwd" show-password style="width: 200px"></el-input>
          <span style="font-size: 14px; color: #00afb5; margin-left: 5px; cursor: pointer" @click="getPayPwd">忘记密码？</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog2 = false">取 消</el-button>
        <el-button type="primary" @click="checkUserAccount('formData')" :loading="nosucecessloading">确 定</el-button>
      </div>
    </el-dialog>
    <ft-com></ft-com>
  </div>
</template>

<script>
import ftCom from "../../components/footer";
import nhCom from "../../components/navheader";
import hdImg from "../../components/headerImg";
import { UserInfo } from "../../components/User/UserInfo";
import { shoppingMall } from "../../components/shoppingMall/shoppingMall";
import { Outpatient } from "@/components/Drug/Outpatient";

var loading = "";
export default {
  inject: ["reload"],
  components: {
    ftCom,
    nhCom,
    hdImg,
  },
  data() {
    var user = new UserInfo(this.TokenClient, this.Services.Authorization);
    var users = new UserInfo(this.TokenClient, this.Services.Statics);
    var UserDistributorltem = new shoppingMall(this.TokenClient, this.Services.Authorization);
    var outpatientAuthorization = new Outpatient(this.TokenClient, this.Services.Authorization);
    return {
      userDomain: user,
      userDomainS: users,
      outpatientAuthorizationDomain: outpatientAuthorization,
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      rules: {
        phone: [
          // { required: true, message: "请输入收款账号", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的手机号", trigger: "blur" },
        ],
        amount: [{ required: true, message: "请输入金额", trigger: "blur" }],
        payPwd: [
          { required: true, message: "请输入支付密码", trigger: "blur" },
          {
            pattern: /(^[0-9]{6}$)/,
            message: "请输入6位数字",
            trigger: "blur",
          },
        ],
      },
      formData: {
        phone: "",
        payeeUserPhone: "",
        payeeUserId: 0, //收款账号
        TransferUserId: 0, //付款账号
        payWay: 0,
        amount: 0,
        type: 0,
        payPwd: "",
      },
      payeeUser: {},
      UserDistributorMain: UserDistributorltem,
      dialog1: false,
      dialog2: false,
      nosucecessloading: false,
      UserBalance: {
        assetsBalance: 0,
      },
    };
  },
  mounted() {
    this.getUserAssetsDetails()
  },
  methods: {
    getUserAssetsDetails() {
      var _this = this;
      _this.UserDistributorMain.getUserDistributor(
        function (data) {
          if (data.data) {
            _this.UserBalance = data.data;
          }
        },
        function (err) {
          console.log(err);
        }
      );
    },
    getPayPwd() {
      const href = this.$router.resolve("/personal/resetPassword");
      window.open(href.href, "_blank");
    },
    saveTransfer() {
      _this.checkUserAccount(form);
    },

    /**
     * 验证支付密码
     * @param loading
     */
    checkUserAccount(form) {
      var _this = this;
      loading = this.$loading({
        lock: true,
        background: "rgba(0, 0, 0, 0.5)",
      });
      _this.outpatientAuthorizationDomain.getIsSetPayPassword(
        async function (data) {
          let res = await _this.getIsPayPassword();
          if (res) {
            // 支付
            _this.submitOrder(form);
          } else {
            loading.close();
            _this.nosucecessloading = false;
            _this.$message({
              type: "warning",
              message: "支付密码错误",
            });
          }
        },
        function (error) {
          loading.close();
          _this.nosucecessloading = false;
          _this
            .$confirm("未设置支付密码？去设置", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              const href = _this.$router.resolve("/personal/resetPassword");
              window.open(href.href, "_blank");
            });
        }
      );
    },
    getIsPayPassword() {
      var _this = this;
      return new Promise((resolve, reject) => {
        _this.outpatientAuthorizationDomain.getIsPayPassword(
          {
            payPassword: _this.formData.payPwd,
          },
          function (data) {
            resolve(true);
          },
          function (error) {
            resolve(false);
          }
        );
      });
    },
    submitOrder() {
      var _this = this;
      let map = {
        amount: _this.formData.amount,
        type: 0,
        payeeUserId: _this.payeeUser.id,
        TransferUserId: _this.userInfo.id,
        payWay: 0,
      };
      _this.UserDistributorMain.BalanceTransfer(
        map,
        function (data) {
          loading.close();
          _this.$message({
            type: "success",
            message: "转账成功",
          });
          _this.reload();
        },
        function (error) {
          loading.close();
          let jsonObj = JSON.parse(error.msg);
          _this.$message({
            message: jsonObj.msg,
            type: "error",
          });
          console.log(error);
        }
      );
    },
    handleClose() {
      this.payeeUser = {
        userName: "",
        phone: "",
      };
      this.formData.payeeUserId = 0;
    },
    searchUser() {
      var _this = this;
      // _this.payeeUser = {};
      let test = /^1[3456789]\d{9}$/;
      if (!test.test(_this.formData.phone)) {
        this.$message({
          type: "error",
          message: "请输入正确的手机号!",
        });
        return;
      }
      _this.UserDistributorMain.PayeeUserInfo(
        _this.formData.phone,
        function (data) {
          if (data.data && data.data.length > 0) {
            _this.payeeUser = data.data[0];
            _this.formData.payeeUserId = _this.payeeUser.id;
          }
        },
        function (error) {
          _this.payeeUser = {
            userName: "",
            phone: "",
          };
          _this.formData.payeeUserId = 0;
          console.log(error);
        }
      );
    },
    saveData() {
      var _this = this;
      if (_this.formData.payeeUserId == 0) {
        _this.$message({
          type: "error",
          message: "请输入正确的手机号，查询收款账号!",
        });
      } else {
        _this.$refs.formData.validateField("amount", (errMsg) => {
          if (errMsg) {
            _this.$message({
              type: "error",
              message: "请输入转账金额!",
            });
            return;
          } else {
            if (_this.formData.amount <= 0) {
            _this.$message({
              type: "error",
              message: "金额必须大于0",
            });
            return
          }
            _this.dialog1 = true;
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/css/footer.css";
.personal-content {
  background: #f2f2f2;
  padding: 40px 0;
}
.personal-box {
  width: 1200px;
  margin: 0 auto;
}
.personal-left {
  float: left;
}
.personal-right {
  float: right;
  width: 985px;
}

.pointer {
  cursor: pointer;
}
.line-title {
  width: 3px;
  height: 16px;
  background: #333;
  margin-right: 5px;
}
.pageTitle {
  font-size: 16px;
  color: #333333;
  font-weight: bold;
}
.content {
  background: #fff;
  border-radius: 8px;
  padding: 20px 15px;
  min-height: 640px;
}
.part-box {
  // width: 50%;
  margin: 0 auto;
  margin-top: 10%;
  .desc {
    margin-top: 10px;
  }
  .tip {
    width: 100%;
    color: #00a391;
    text-align: center;
  }
  .payWay {
    padding: 10px 60px 0 60px;
    border: 1px solid #e0e0e0;
    margin-right: 20px;
    position: relative;
    cursor: pointer;
  }
  .payWayActive {
    border: 1px solid #1fb7a6;
  }
  .jiaoImg {
    position: absolute;
    right: 0;
  }
  .activeImg {
    bottom: -1px;
  }
  .imgBoxurl1 {
    width: 180px;
    height: 180px;
  }
}
.pay-bg {
  position: relative;
  margin: 20px auto;
  width: 180px;
  height: 180px;
  background: url("../../assets/img/userInfo/pc_line.png") top center no-repeat;
  background-size: cover;
}

.pay-bg img {
  position: absolute;
  width: 160px;
  top: 10px;
  left: 10px;
}
.bg {
  background: linear-gradient(90deg, #f9f7df, #e3f5f3);
  border-radius: 4px;
  margin-bottom: 20px;
  font-weight: bold;
  padding: 10px 20px;
  line-height: 2;
}
</style>
